module.exports = __webpack_public_path__ + "img/back_home.40f4acf2.jpg";